/**
 * @generated SignedSource<<083ab48759924b94caedbac882c01633>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ABTestResolutionProviderQuery$variables = {};
export type ABTestResolutionProviderQuery$data = {
  readonly abTestResolutions: ReadonlyArray<{
    readonly resolvedVariant: string;
    readonly testId: string;
  }>;
};
export type ABTestResolutionProviderQuery = {
  response: ABTestResolutionProviderQuery$data;
  variables: ABTestResolutionProviderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ABTestResolutionPublic",
    "kind": "LinkedField",
    "name": "abTestResolutions",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "testId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "resolvedVariant",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ABTestResolutionProviderQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ABTestResolutionProviderQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "86d6ea72123796d738ca37c5a230b606",
    "id": null,
    "metadata": {},
    "name": "ABTestResolutionProviderQuery",
    "operationKind": "query",
    "text": "query ABTestResolutionProviderQuery {\n  abTestResolutions {\n    testId\n    resolvedVariant\n  }\n}\n"
  }
};
})();

(node as any).hash = "a9a18f6823727853f0e61398338b41d1";

export default node;
